var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\r\n  1\r\n")])}
var staticRenderFns = []

export { render, staticRenderFns }